<template>
  <div>
    <div class="headForm">
      <a-tabs @change="callback">
        <a-tab-pane key="1" tab="肉禽">
          <meat></meat>
        </a-tab-pane>
        <a-tab-pane key="2" tab="蛋禽" force-render>
          <egg></egg>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>
<script>
import Egg from './Egg.vue'
import Meat from './Meat.vue'
export default {
  components:{Egg,Meat},
  data() {
    return {};
  },
  methods: {
    callback() {},
  },
};
</script>
